import { render, staticRenderFns } from "./attachmentUpload.vue?vue&type=template&id=39c92c43"
import script from "./attachmentUpload.vue?vue&type=script&lang=js"
export * from "./attachmentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports